import React from 'react'

export default function Cesantias() {
  return (
    <div>
      Cesantias
    </div>
  )
}
